<template>
  <div class="ui-field" :class="{ 'ui-field--full': full }">
    <label :for="inputId">{{ label }}<span v-if="required" aria-hidden="true"> *</span></label>
    <select v-if="options" :id="inputId" :value="value" :aria-invalid="String(Boolean(error))" :aria-describedby="error ? errorId : null" @change="$emit('input', $event.target.value)">
      <option v-for="option in options" :key="option.value" :value="option.value">{{ option.label }}</option>
    </select>
    <input v-else :id="inputId" :type="type" :value="value" :readonly="readonly" :required="required" :autocomplete="autocomplete" :inputmode="inputmode" :aria-invalid="String(Boolean(error))" :aria-describedby="error ? errorId : null" @input="$emit('input', $event.target.value)" />
    <span v-if="error" :id="errorId" class="ui-field__err">{{ error }}</span>
    <span v-else-if="hint" class="ui-field__hint">{{ hint }}</span>
  </div>
</template>

<script>
/** Polje forme: oznaka, unos (ili izbor kad ima options), greška ispod polja (poruka backenda ili naša) i napomena. v-model. */
export default {
  name: "UiField",
  props: {
    name: { type: String, required: true },
    label: { type: String, required: true },
    value: { type: [String, Number], default: "" },
    type: { type: String, default: "text" },
    options: { type: Array, default: null },
    error: { type: String, default: "" },
    hint: { type: String, default: "" },
    required: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    full: { type: Boolean, default: false },
    autocomplete: { type: String, default: "off" },
    inputmode: { type: String, default: null },
  },
  computed: {
    inputId() {
      return `ui-f-${this.name}`;
    },
    errorId() {
      return `${this.inputId}-error`;
    },
  },
};
</script>
